import React from 'react';

const MaintenanceActivities = () => {
  return (
    <div className="container mx-auto mt-8">
      <h2 className="text-2xl font-bold mb-4">Aktivitetet e Mirëmbajtjes</h2>
      <ul className="list-disc pl-4">
        <li>Mirëmbajtja e zonave gjelbër rreth ndërtesave banimore dhe lagjeve të banimit</li>
        <li>Aktivitetet e arkitekturës së peizazhit</li>
        <li>Mirëmbajtja e fusheve sportive dhe stadiumeve</li>
        <li>Ndërtimi dhe mirëmbajtja e fontanave</li>
        <li>Aktivitetet në lidhje me rekuizitat e parqeve dhe oborreve</li>
        <li>Aktivitetet dekoruese të kopshtarie</li>
        <li>Prodhimi i luleve, shkurreve, dhe drunjëve</li>
        <li>Tregtia me shumicë e luleve dhe bimëve</li>
        <li>Kulturat e perimeve, hortikultura, dhe fidanishtja për mbledhjen e kërpudhave pyjore</li>
        <li>Pylltaria dhe prerja e drunjëve</li>
        <li>Pastrimi sanitare</li>
        <li>Mirëmbajtja e varrezave në territorin e Komunës së Prishtinës</li>
        <li>Veprimtaria funerale dhe të ngjashme</li>
        <li>Aktivitetet shërbimi për mirëmbajtjen dhe kujdesin e shesheve dhe rrugëve</li>
        <li>Veprimtari të tjera rekreacioni</li>
        <li>Mirëmbajtja e hapësirave publike</li>
        <li>Aktivitetet tjera shërbyese</li>
      </ul>

      <h2 className="text-2xl font-bold my-4">Përgjegjësitë Shtesë</h2>
      <ul className="list-disc pl-4">
        <li>Mirëmbajtja, menaxhimi dhe sigurimi i parqeve malore si Parku Kombëtar Gërmia, kompleksi i parkut malor Kërpa-Kravaricë, dhe kompleksi i Katundit të Ri, të cilat janë në mbrojtje të posaçme nga Komuna e Prishtinës</li>
        <li>Rregullimi dhe mirëmbajtja e parqeve dhe zonave të gjelbëruara në territorin e Komunës së Prishtinës</li>
        <li>Menaxhimi i tregjeve (Auto-tregu, tregu mobil, dhe tregu i drunjëve) të Komunës së Prishtinës</li>
      </ul>
    </div>
  );
};

export default MaintenanceActivities;
